import axios from 'axios';

const api = axios.create({
    timeout: 120000,
});

export { api };
